import type { GoalWithSubtasks } from './types';

const REVIEW_UI_BUCKETS = new Set(['goal_admission_review', 'user_review_waiting']);

export function normalSurfaceVisibility(goal: GoalWithSubtasks): 'show' | 'hide' | 'history_only' {
  return goal.simplified_action_intake?.ui?.normal_surface_visibility ?? 'show';
}

export function hasSimplifiedIntakeUi(goal: GoalWithSubtasks): boolean {
  return Boolean(goal.simplified_action_intake?.ui);
}

export function isGoalShownOnNormalSurface(goal: GoalWithSubtasks): boolean {
  const visibility = normalSurfaceVisibility(goal);
  return visibility === 'show' || (visibility === 'history_only' && goal.status === 'done');
}

export function isGoalReviewSurface(goal: GoalWithSubtasks): boolean {
  const ui = goal.simplified_action_intake?.ui;
  if (ui) return REVIEW_UI_BUCKETS.has(ui.ui_bucket ?? '');
  return (goal.subtasks || []).some(st => st.status === 'review');
}

export function isGoalOpenNormalSurface(goal: GoalWithSubtasks, isCompleting = false): boolean {
  if (!isGoalShownOnNormalSurface(goal)) return false;
  return goal.status !== 'done' || isCompleting;
}

export function isGoalActiveSurface(goal: GoalWithSubtasks, isCompleting = false): boolean {
  if (!isGoalOpenNormalSurface(goal, isCompleting)) return false;
  if (hasSimplifiedIntakeUi(goal)) return !isGoalReviewSurface(goal);
  return true;
}
